<template>
  <div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow" v-if="afficherActionGroupe">
            <selecteur-action
              @handleAction="handleAction"
              :options="actions"
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllContratSelected().length > 0"
            ></selecteur-action>
          </div>
          <div class="column is-narrow">
            <form @submit.prevent="recherche()">
              <b-input :placeholder="$t('general.placeHolder.search')"
                       type="search"
                       v-model="critereRecherche.auto"
                       icon="magnify">
              </b-input>
            </form>
          </div>
          <div class="column is-narrow">
            <button class="button" @click="setShowFiltre">
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="getFilteredNumber > 0 ? '' : 'is-invisible'">
                  ({{ getFilteredNumber }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permContrat.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable"
      v-if="startArrayRendering && mountedLoadingEnd">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"
        />
      </template>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="contrats">
        </table-footer-totaux>
      </template>
      <template  #indexation = "{ row }">
        <b-icon v-if="row.estIndexe" type="is-primary" icon="cash-plus" size="small"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <qd-checkbox v-if="props.row.selected !== undefined"
                    v-model="props.row.selected"
                    :value="props.row">
        </qd-checkbox>
      </div>
      <div slot="code" slot-scope="props">
        <router-link :to="{ name: 'c.baux.contrat', params: { id: props.row.id } }"
                     v-if="props.row.id"
                     class="lien" :class="{'text-access-no-permission':
                     !checkPermissions(permContrat.lecture)}">
          {{ props.row.code }}
        </router-link>
      </div>
      <div slot="type" slot-scope="props">
        {{ $t(getTypeLibelleContrat(props.row.type)) }}
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getEtatContrat(props.row.etat)) }}
      </div>
      <div slot="dateDebutSignature" slot-scope="props">
        {{ props.row.dateDebutSignature | formatDate }}
      </div>
      <div slot="dateFinSignature" slot-scope="props">
        {{ props.row.dateFinSignature | formatDate }}
      </div>
      <div slot="bailleur" slot-scope="props">
        {{ getLibelleBailleur(props.row.intervenants) }}
      </div>
      <div slot="loyerAnnuelHt" slot-scope="props" class="right"
           :class="{ 'has-text-weight-bold' : props.row.selected === undefined}">
        {{ props.row.loyerAnnuelHt | formatDevise }}
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId)}}
      </div>
      <div slot="exporter" slot-scope="props" class="has-text-centered">
        <a @click="checkPermissions(permContrat.editer) ? edition({
          format: constantes.TYPE_PDF,
          typeDonnee: constantes.TYPE_EDITION_CONTRAT_CRIP },
          props.row.id,
        ) : showPopUp()">
          <b-icon
            :key="props.id"
            icon="file-pdf-box"
            type="is-primary"
            :class="{'text-access-no-permission' : !checkPermissions(permContrat.editer)}"/>
        </a>
      </div>
      <div slot="edit" slot-scope="props" class="has-text-centered">
        <a @click="checkPermissions(permContrat.maj) ?
                $router.push({name: 'm.baux.contrat-edit', params: {id: props.row.id }})
             : showPopUp()">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{'text-access-no-permission' :
                  !checkPermissions(permContrat.maj)}">
          </b-icon>
        </a>
      </div>
      <div slot="archiver">
        <div @click="checkPermissions(permContrat.supprimer) ? inProgress() :
            showPopUp()" class="is-cursor-pointer">
          <b-icon type="is-default" icon="archive"
                  :class="{ 'text-access-no-permission' :
                           !checkPermissions(permContrat.supprimer) }">
          </b-icon>
        </div>
      </div>
      <div slot="delete" class="has-text-centered" slot-scope="props">
        <a @click="checkPermissions(permContrat.supprimer)
          ? openPopUpDelete(props.row) : showPopUp()"
          :class="{ 'disabled': props.row.etat !== constantes.CONTRAT_ETAT_BROUILLON }">
          <b-icon icon="delete-forever" type="is-danger"
                  :class="{'text-access-no-permission' :
                  !checkPermissions(permContrat.supprimer)}">
          </b-icon>
        </a>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre">
        <filtre-liste-contrat ref="filtreListeContrat"
                              @toggleFiltre="setShowFiltre"
                              @recherche="makeRechercheFilter" :hideBailleur="isDetailBailleur"
                              :critereRecherche="critereRecherche"/>
      </div>
    </transition>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="contratIds.length > 1
                          ? this.$t('listeContrat.popUpSuppression.titleMulti')
                          : this.$t('listeContrat.popUpSuppression.title')"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteContrat"/>
    </b-modal>
    <b-modal
      v-model="popUpActionSecteur"
      has-modal-card
      class="modal"
      width="600px">
      <pop-up-manage-secteur
        :secteur-type="constantes.PATRIMOINE"
        :itemsIds="getAllContratSelected().map((el) => el.id)"
        :action-secteur="func.ajoutSecteurAsync"
        :isAdd="true"
        :libelle-list="libelleListManageSecteur"
        :translator="func.translatorSecteurBaux"
        :validation="func.validationContrat"
        :refresh="recherche"
        @close="popUpActionSecteur = false"
      />
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { CONTRAT } from '@/configuration/baux/permissionsBauxConf';
import selecteurAction from '@/components/general/selecteurAction';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import {
  LISTE_ETAT_CONTRAT,
  LISTE_TYPE_CONTRAT,
  EXPORT_EXCEL_TYPE_DONNEES_CONTRATS,
  TYPE_EDITION_CONTRAT_CRIP,
  CONTRAT_ETAT_BROUILLON,
} from '@/configuration/baux/contrat/contratConf';
import inProgress from '@/services/general/inProgress';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import filtreListeContrat from '@/components/baux/contrat/filtre/filtreListeContrat';
import { SET_CRITERE } from '@/store/modules/baux/contrat-mutation-type';
import formatIsoDate from '@/services/general/formatIsoDate';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { get as getTiers } from '@/api/tiers/index';
import transform from '@/services/baux/contrat/contratServerTableDataTransformer';
import genererCritereRechercheContrat from '@/services/baux/contrat/genererCritereRechercheContrat';
import edition from '@/api/edition/index';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import {
  ACTION_MASS_EDITION, ACTION_DELETE,
  ACTION_MASS_AJOUTER_SECTEUR,
} from '@/configuration/general/actionsConf';
import { deleteContrat, ajoutSecteurAsync } from '@/api/baux/contrat';
import messageSucces from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import validation from '@/services/baux/contrat/validationDelete';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_LISTE_CONTRAT } from '@/configuration/general/referenceTableConf';
import { PATRIMOINE } from '@/configuration/parametrage/secteurConf';
import getSecteursIdByUser from '@/services/commun/secteur/getSecteurs';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import popUpManageSecteur from '@/components/commun/secteur/p_manageSecteur';
import translatorSecteurBaux from '@/services/secteur/translatorSecteurBaux';
import validationContrat from '@/services/baux/contrat/validation';

const Permissions = createNamespacedHelpers('permissions');
const Contrat = createNamespacedHelpers('contrat');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    afficherColonneAction: {
      required: false,
      type: Boolean,
      default: true,
    },
    afficherActionGroupe: {
      required: false,
      type: Boolean,
      default: true,
    },
    tiers: {
      required: false,
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      permContrat: CONTRAT,
      showFiltre: false,
      unsubscribeValue: null,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      constantes: {
        TYPE_PDF,
        TYPE_EDITION_CONTRAT_CRIP,
        CONTRAT_ETAT_BROUILLON,
        ACTION_MASS_AJOUTER_SECTEUR,
        PATRIMOINE,
      },
      popUpSuppression: false,
      messagesErreurPopUp: [],
      errorPopUp: false,
      contratIds: [],
      referenceTable: REFERENCE_TABLE_LISTE_CONTRAT,
      resultPerPage: RESULTS_PER_PAGE,
      popUpActionSecteur: false,
      func: {
        ajoutSecteurAsync,
        translatorSecteurBaux,
        validationContrat,
      },
    };
  },
  components: {
    selecteurAction,
    TableItemsInView,
    filtreListeContrat,
    popUpPrevention,
    tableFooterTotaux,
    exportExcelButton,
    parametrageTable,
    popUpManageSecteur,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Contrat.mapGetters({
      contrats: 'items',
      totalCount: 'totalCount',
      critereRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    allContratSelected() {
      return this.getAllContratSelected().length === this.contrats.length
        && this.contrats.length > 0;
    },
    iconSelectTotal() {
      if (this.allContratSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeContrat.tab.code'),
          indexation: this.$i18n.t('listeContrat.tab.indexation'),
          type: this.$i18n.t('listeContrat.tab.type'),
          dateDebutSignature: this.$i18n.t('listeContrat.tab.debutContrat'),
          dateFinSignature: this.$i18n.t('listeContrat.tab.finContrat'),
          bailleur: this.$i18n.t('listeContrat.tab.bailleur'),
          loyerAnnuelHt: this.$i18n.t('listeContrat.tab.loyer'),
          etat: this.$i18n.t('listeContrat.tab.etat'),
          agence: this.$i18n.t('listeContrat.tab.agence'),
          'nature.libelle': this.$i18n.t('listeContrat.tab.natureBail'),
          exporter: '',
          edit: '',
          archiver: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          if (data.query.tiersId.length > 0) {
            data.query.tiersId = data.query.tiersId.map((tiers) => { return tiers.id; });
          }
          data.query.periodeContrats.dateDebut = formatIsoDate(
            data.query.periodeContrats.dateDebut,
          );
          data.query.periodeContrats.dateFin = formatIsoDate(data.query.periodeContrats.dateFin);
          data.query.datePreavis.dateFin = formatIsoDate(data.query.datePreavis.dateFin);
          data.query.datePreavis.dateDebut = formatIsoDate(data.query.datePreavis.dateDebut);
          data.query.societeId = this.societeActiveId;
          if (this.critereRecherche.agencesId.length === 0) {
            data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          if (this.critereRecherche.demarcheurIds.length) {
            data.query.demarcheurIds = this.critereRecherche.demarcheurIds.map(el => el.id);
          }
          return this.actionLoadContrat(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.contrats,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          exporter: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
          selected: 'colonneSelected',
          indexation: 'has-text-centered',
        },
        sortable: ['code', 'indexation', 'type', 'dateDebutSignature', 'dateFinSignature', 'loyerAnnuelHt', 'etat', 'agence', 'nature.libelle'],
      };
    },
    isDetailBailleur() {
      return this.$route.name.startsWith('c.baux.bailleur');
    },
    getFilteredNumber() {
      const critereBan = ['auto', 'datePreavis', 'periodeContrats', 'societeId', 'estIndexe', 'paiementSurFacture', 'blocagePaiement'];
      if (this.isDetailBailleur) {
        critereBan.push('tiersId');
      }
      let nbCritere = calculNombreCritere(this.critereRecherche, critereBan);
      if (!this.critereRecherche.hasSecteur
        && this.critereRecherche.hasSecteur !== null) nbCritere += 1;
      if (this.critereRecherche.periodeContrats.dateDebut
        || this.critereRecherche.periodeContrats.dateFin) nbCritere += 1;
      if (this.critereRecherche.datePreavis.dateDebut
        || this.critereRecherche.datePreavis.dateFin) nbCritere += 1;
      if (this.critereRecherche.estIndexe !== null) nbCritere += 1;
      if (this.critereRecherche.paiementSurFacture !== null) nbCritere += 1;
      if (this.critereRecherche.blocagePaiement !== null) nbCritere += 1;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    targetTotal() {
      return ['loyerAnnuelHt'];
    },
    columns() {
      const columns = ['selected', 'code', 'indexation', 'nature.libelle', 'type', 'bailleur', 'dateDebutSignature', 'dateFinSignature', 'loyerAnnuelHt', 'etat'];
      if (this.afficherColonneAction) {
        columns.push('exporter');
        columns.push('edit');
        columns.push('archiver');
        columns.push('delete');
      }
      if (this.agencesSelectionnees.length > 1) columns.splice(columns.length - 4, 0, 'agence');
      return columns;
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    actions() {
      return [
        {
          action: ACTION_MASS_EDITION,
          translation: 'listeContrat.actions.edition',
          show: true,
        },
        {
          action: ACTION_DELETE,
          translation: 'listeContrat.actions.delete',
          show: true,
        },
        {
          action: ACTION_MASS_AJOUTER_SECTEUR,
          translation: 'addSecteurLien.actions.addSecteur',
          show: this.moduleSecteurActive,
        },
      ].filter(el => el.show);
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_TYPE_DONNEES_CONTRATS,
        typeExport: '',
        filtres: transform(this.lastPayload),
      };
    },
    libelleListManageSecteur() {
      return [{
        isLink: false,
        libelle: this.$i18n.t('addSecteurLien.textInfo'),
      }];
    },
  },
  methods: {
    ...Contrat.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Contrat.mapActions({
      actionLoadContrat: 'loadContrat',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    updateAgenceAndRecherche() {
      this.critereRecherche.agencesId = [];
      this.recherche();
    },
    makeRechercheFilter(critereUpdate) {
      this.setCritereRecherche(critereUpdate);
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeContrat.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    selectAll() {
      const select = !this.allContratSelected;
      this.contrats.forEach((el) => {
        if (el.selected !== undefined) el.selected = select;
      });
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      return agence ? agence.libelleAgence : '';
    },
    getLibelleBailleur(bailleurs) {
      let bailleurLibelle = '';
      if (!bailleurs) return '';
      bailleurs.forEach((bailleur) => {
        if (bailleurLibelle) bailleurLibelle += ', ';
        bailleurLibelle += bailleur.tiers.nomCommercial;
      });
      return bailleurLibelle;
    },
    getTypeLibelleContrat(type) {
      const typeFind = LISTE_TYPE_CONTRAT.find((listeType) => {
        return listeType.code === type;
      });
      return typeFind ? typeFind.libelle : '';
    },
    getEtatContrat(etat) {
      const etatFind = LISTE_ETAT_CONTRAT.find((listeEtat) => {
        return listeEtat.code === etat;
      });
      return etatFind ? etatFind.libelle : '';
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    inProgress() {
      inProgress(this.$i18n);
    },
    getAllContratSelected() {
      return this.contrats.filter((el) => {
        return el.selected;
      });
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeContrat.initializeFiltre();
      this.$refs.filtreListeContrat.viderCritere();
      this.$refs.filtreListeContrat.appliquerCritere();
      this.showFiltre = false;
    },
    handleAction(action) {
      switch (action) {
        case ACTION_MASS_EDITION:
          if (this.checkPermissions(this.permContrat.editer)) {
            this.edition({
              format: this.constantes.TYPE_PDF,
              typeDonnee: this.constantes.TYPE_EDITION_CONTRAT_CRIP,
            });
          } else this.showPopUp();
          break;
        case ACTION_DELETE:
          if (this.checkPermissions(this.permContrat.supprimer)) {
            this.popUpSuppression = true;
            this.errorPopUp = false;
            this.messagesErreurPopUp = [];
            this.contratIds = this.contrats.filter((el) => {
              return el.selected;
            }).map((el) => { return el.id; });
          } else this.showPopUp();
          break;
        case ACTION_MASS_AJOUTER_SECTEUR:
          if (this.checkPermissions(this.permContrat.maj)) {
            this.popUpActionSecteur = true;
          } else this.showPopUp();
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFactures.error.noActionSelect'));
          break;
      }
    },
    async edition(donnees, id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: id ? [id] : this.getAllContratSelected().map((el => el.id)),
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    openPopUpDelete(contrat) {
      this.popUpSuppression = true;
      this.contratIds = [contrat.id];
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
    },
    async deleteContrat() {
      this.messagesErreurPopUp = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteContrat(this.contratIds);
        messageSucces(this.contratIds.length > 1
          ? this.$t('listeContrat.popUpSuppression.sucess.bauxMulti')
          : this.$t('listeContrat.popUpSuppression.sucess.bailDelete'));
        loadingComponent.close();
        this.popUpSuppression = false;
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw e;
      }
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.moduleSecteur.key]);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      if (this.isDetailBailleur || this.$route.name === 'l.baux.contrat-by-tiers') {
        const tiers = (await getTiers(this.$route.params.id)).data.result;
        this.critereRecherche.tiersId = [tiers];
      }
      if (this.$route.name === 'c.baux.bailleur-contrat' && this.tiers) {
        this.setCritereRecherche(genererCritereRechercheContrat());
        this.critereRecherche.tiersId = [this.tiers];
      }
      const secteurIdsCurrentUser = (await getSecteursIdByUser(PATRIMOINE)).map(e => e.id);
      if (secteurIdsCurrentUser.length) this.critereRecherche.secteurIds = secteurIdsCurrentUser;
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
